
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const router = useRouter();
    return {
      router,
    };
  },
  name: "AgreementDialog",
  components: {},

  computed: {
    headTitle() {
      return "爱心求助需知";
    },
  },
  methods: {
    async open() {
      this.show = true;
    },
    async close() {
      this.show = false;
    },
    tongyi() {
      this.$emit("agreementState");
      this.show = false;
    },
  },
  data() {
    return {
      show: false,
    };
  },
});
